// extracted by mini-css-extract-plugin
export var sliderRange = "_oc-2";
export var sliderRoot = "_oc-0";
export var sliderThumb = "_oc-3";
export var sliderTrack = "_oc-1";